import React, { useState } from 'react';
import { ChevronDown } from 'lucide-react';

const faqs = [
  {
    question: "Qu'est-ce qui est inclus dans les 6 500€ ?",
    answer: "Tout est inclus : hébergement en chambre individuelle avec salle de bain privée, pension complète (chef privé), toutes les activités sportives (boxe, vélo, kitesurf), workshops business & IA, Cayenne Experience, hammam, massages, transferts aéroport. Seul le vol n'est pas inclus."
  },
  {
    question: "Comment se passe la sélection ?",
    answer: "On cherche des entrepreneurs ambitieux, prêts à s'engager à 100%. Des hommes qui veulent se développer, devenir plus forts mentalement et physiquement. Des businessmen prêts à se couper du monde pendant 6 jours pour revenir transformés. Si c'est toi, candidate. On te recontacte sous 48h."
  },
  {
    question: "Quel est le niveau sportif requis ?",
    answer: "Aucun niveau minimum. Que tu sois débutant ou athlète, chaque activité est adaptée à ton niveau. L'important c'est l'état d'esprit : vouloir se dépasser et sortir de sa zone de confort."
  },
  {
    question: "Puis-je facturer en formation professionnelle ?",
    answer: "Oui. VIVANT peut être facturé comme 'Séminaire de développement des compétences entrepreneuriales' ou 'Formation intensive business & leadership'. C'est déductible des charges de ton entreprise."
  },
  {
    question: "Combien de participants par session ?",
    answer: "Maximum 10-12 entrepreneurs par session. On garde volontairement un petit groupe pour garantir la qualité des échanges et créer de vraies connexions."
  },
  {
    question: "Comment venir à Essaouira ?",
    answer: "Vol direct vers Essaouira (ESU) ou via Marrakech (RAK) + 2h30 de route. Les transferts aéroport sont inclus et organisés par notre équipe."
  }
];

const FAQSection = () => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleFAQ = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <div className="bg-[#0a0a0a] py-20 px-6 border-t border-white/5" data-testid="faq-section">
      <div className="max-w-3xl mx-auto">
        <div className="text-center mb-12">
          <p className="text-[#D4A574] text-[10px] tracking-[0.4em] mb-4">QUESTIONS</p>
          <h2 className="font-italiana text-3xl md:text-4xl text-white tracking-[0.08em] uppercase">
            Tout ce que tu veux <span className="text-[#D4A574]">savoir</span>
          </h2>
        </div>

        <div className="space-y-3">
          {faqs.map((faq, index) => (
            <div 
              key={index}
              className="bg-white/5 border border-white/10 rounded-xl overflow-hidden"
            >
              <button
                onClick={() => toggleFAQ(index)}
                className="w-full px-6 py-5 flex items-center justify-between text-left hover:bg-white/5 transition-colors"
              >
                <span className="text-white text-sm md:text-base font-medium pr-4">{faq.question}</span>
                <ChevronDown 
                  className={`w-5 h-5 text-[#D4A574] flex-shrink-0 transition-transform duration-300 ${
                    openIndex === index ? 'rotate-180' : ''
                  }`}
                />
              </button>
              <div 
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <p className="px-6 pb-5 text-white/60 text-sm leading-relaxed">
                  {faq.answer}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-10">
          <p className="text-white/40 text-xs">
            Une autre question ? <a href="mailto:contact@vivant.fr" className="text-[#D4A574] hover:underline">Écris-nous</a>
          </p>
        </div>
      </div>
    </div>
  );
};

export default FAQSection;
